import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Card, NavLink, Badge} from 'react-bootstrap';
import { LAYOUT } from 'constants.js';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import Clamp from 'components/clamp';
import _ from 'lodash';
import PropTypes from 'prop-types';

import Certifications from './certifications';
import Trainings from './trainings';



const TrainingCertifications = ({user, ...props}) => {
  const {certification, training} = user
  return (
    <div>
      {/* Certifications Start */}      
      <h2 className="ms-1 mt-3 mb-0 small-title"><CsLineIcons icon="diploma" size="20" className="me-2"/>Certifications</h2>
      {!((certification && !_.isEmpty(certification))) && <Row className="g-0">
        <Col>
          <Card className="h-100">
            <Card.Body className="d-flex flex-column justify-content-start">
              <div class="text-muted">No certifications added.</div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      }
      {(certification && !_.isEmpty(certification)) && certification.map((item)=><Certifications key={item.id} user={user} certification={item} />)}
      {/* Certifications End */}
      
      {/* Trainings Start */}
      <h2 className="ms-1 mt-5 mb-0 small-title"><CsLineIcons icon="online-class" size="20" className="me-2"/>Trainings & Courses</h2>
      {!((training && !_.isEmpty(training))) && <Row className="g-0">
        <Col>
          <Card className="h-100">
            <Card.Body className="d-flex flex-column justify-content-start">
              <div class="text-muted">No trainings added.</div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      }
      {(training && !_.isEmpty(training)) && training.map((item)=><Trainings key={item.id} user={user} training={item} />)}
      {/* Trainings End */}
    </div>
  );
};

export default TrainingCertifications;
TrainingCertifications.propTypes = {
  user: PropTypes.object.isRequired,
}